const handleClickLogin = (sns: string) => {
  sessionStorage.setItem('redirectUrl', window.location.href);

  const redirectUrl = `${
    process.env.REACT_APP_API_URL
  }/oauth/${sns}?host=${encodeURIComponent(
    window.location.origin + '/user/login'
  )}`;

  window.location.href = redirectUrl;
};

export { handleClickLogin };
